module.exports = __webpack_public_path__ + "assets/877b0ebcd7148719d5d3d16670b6e401.svg";